/**
 * @generated SignedSource<<6d1345a797cf22c1394a0cdfcc64572f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRestrictedMaterialsLoader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRestrictedMaterials_viewer">;
  readonly " $fragmentType": "PdpSharedRestrictedMaterialsLoader_viewer";
};
export type PdpSharedRestrictedMaterialsLoader_viewer$key = {
  readonly " $data"?: PdpSharedRestrictedMaterialsLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRestrictedMaterialsLoader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRestrictedMaterialsLoader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRestrictedMaterials_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d15903ca6efbbdf895843b6ad7eb06b8";

export default node;
